<template>
  <div ref="echartPie" style="width:100%;height:100%;">
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  name:'echartPie',
  props: {
    echartPieData:{
      type:Array,
      default:[]
    },
    
  },
  data(){
    return {
      colors : ['#5793f3', '#d14a61'],
      legends:['成交客户构成']
    }
  },
  mounted(){
    this.getEchart();
  },
  watch:{
    echartPieData(n,o){
      this.$nextTick(()=> {
        this.getEchart();
      });
    },
  },
  methods:{
    getEchart(){
        let legend=[]
        this.echartPieData.forEach(t => {
          legend.push(t.name)
        });
        let myChart =  echarts.init(this.$refs.echartPie)
        let option = {
          tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          title: {
              text: '成交客户构成',
              textStyle :{
                color:'#666',
                fontSize:'16'
              }
          },
          legend: {
              orient: 'vertical',
              left:10,
              top:60,
              show: true,
              data:legend
          },
          // legend: {
          //     show: true,
          //     data: ['A', 'B', 'C']
          // },
          color:['#5bc49f','#ff7c7c'],
          series: [
            {
              name:'成交客户构成',
              type:'pie',
              center: ['50%', '60%'],
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              label: {
                  normal: {
                      show: false,
                      position: 'center'
                  },
                  emphasis: {
                      show: true,
                      textStyle: {
                          fontSize: '14',
                          fontWeight: 'bold'
                      }
                  }
              },
              labelLine: {
                  normal: {
                      show: false
                  }
              },
              data:this.echartPieData
            }
          ]
        };
        myChart.setOption(option);
    }
  }
}
</script>